import URL from '../helper';
import axiosCall from './interceptor';

export const getEmailRequestList = async payload => {
  const searchParams = new URLSearchParams(payload);
  const url = `${URL.BASE_URL}transactionAPIAudit?${searchParams}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getEmailAuditDetails = async id => {
  const url = `${URL.BASE_URL}emailAudit?mailRequestId=${id}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const downloadFile = async (payload) => {
  const searchParams = new URLSearchParams(payload);
  const url = `${URL.EML_DOWNLOAD_URL}export?${searchParams}`;
  window.open(url);
  return true;
};
